<template>
  <section>
    <section class="flex Banner bg-cover bg-no-repeat flex-col items-center w-full "> 
      <banner
        class=" bg-center bg-cover bg-no-repeat"
        :withBorder="false"
        :Banner="Banner"
        :landing="2"
      />
    </section>
    <section class="flex flex-col items-center  ">
      <secondary-banner
        :arrowButton="true"
        :withBorder="false"
        :banner="SecondBanner"
      />
    </section>
    <section
      v-if="true"
      class="flex flex-col items-center   w-full bg-gradient-to-r from-bluedy via-bluedy2 to-bluedy3"
    >
      <third-banner :withBorder="false" :banner="ThirdBanner" />
 
    </section>
  </section>
</template>

<script>

import Banner from "../../../../v2/src/sections/Banner.vue";
import SecondaryBanner from "../../../../v2/src/sections/SecondaryBannerImg.vue";
import ThirdBanner from "../../../../v2/src/sections/ThirdBanner.vue";

export default {
 metaInfo: {
      title: '10 obstaculos en telemedicina',
      meta: [
          { name: 'description',
              content: '10 obstáculos más frecuentes de los profesionales de los profesionales de la salud al momento de iniciar con Telemedicina',
         }
      ],
  },
  data: () => ({
    Banner: {
      title: "TELEMEDICINA",
      text: "MÁS FRECUENTES DE LOS PROFESIONALES DE LA SALUD AL MOMENTO DE INICIAR LA",
      span: "LOS 10 OBSTÁCULOS ",
      register: "Regístrate gratis",
      buttonText:"Enviar",

      registerStyle: "bg-white shadow-register rounded-2.5 text-left  ",
      titleStyle: "lg:text-35.2 text-30px font-bold text-white",
      firstTextStyle: "lg:text-35.2 text-30px font-bold text-white uppercase leading-mini-snug ",
      spanStyle:"text-white opacity-95 ",
      buttonStyles: "lg:max-w-62.5 h-11 py-0 rounded-5.5 text-base bg-btn",
      registerTextStyle: " lg:text-left ml-8 ",

      btnText: false,
      firstButton: false,
      textReverse: true,
    },

    SecondBanner: {
      title: "LA TELEMEDICINA LLEGÓ PARA QUEDARSE… NO HAY DUDA",
      firstText:
        "Hay numerosos pacientes que requieren de tus servicios pero razones de tiempo, distancia, acceso al lugar  o incluso desconocimiento de la existencia del profesional, le impiden llegar a tener tu atención y resolver sus situaciones de salud.",
      secondText:
        "La incorporación de la telemedicina al sistema de salud permite ofrecer servicios de salud a personas que, de otro modo, no pueden acceder a tí.",
      thirdText:
        "Es por eso que, en estos momentos donde  la tecnología de información y comunicación puede ser el aliado perfecto para lograr resolver estas limitaciones,  es indispensable  ampliar el acceso a muchos más que requieren tus servicios.",

      buttonText: 'Registrate',

      textSectionStyle: "bg-white text-black xl:ml-159px  pb-15 lg:pb-0 xl:justify-start md:justify-start",
      titleStyle: "text-black",
      textsStyle: "text-black text-base  xl:pr-0",
      buttonStyles: "md:max-w-62.5 h-11 py-0 rounded-5.5 text-base lg:mb-54px xl:mb-0 bg-btn",
      img: 'tertiaryBanner.webp', 

      Button: true,
      arrowButton: true,
    },
    ThirdBanner:{
       bigTitle: 'ES EL MOMENTO DE VENCER LOS MITOS, DUDAS Y ASUMIR LOS RETOS QUE IMPLICA LA TELEMEDICINA HOY',
       bigText: 'Entendemos tus miedos y angustias ¿Será para mí? ¿Los pacientes se adaptarán? ¿Y si me equivoco? ¿Y qué va a pasar cuando no pueda resolver vía telemedicina? ¿Es ilegal?. Estas y muchas otras dudas son muy frecuentes,  por eso hemos creado la guía para ayudarte a despejarlas y de ese modo lograr ayudarte a expandir tus servicios más y mejor.',
       
       firstTitle:'FÁCIL',
       firstText: 'Cuanto más te enteres verás que agradable y práctico es para ti y tu paciente.',
       
       secondTitle:'ACCESIBLE',
       secondText: 'Actualmente las plataformas son muy intuitivas y amigables, y resultan accesibles, ameritan internet de incluso poco ancho de banda.',

       thirdTitle:'LEGAL',
       thirdText: 'Si cumples los pasos claves de ética, la legalidad es muy simple y aplica para todos.',

       quarteTitle:'SEGURA',
       quarteText: 'Permitirá ayudar a muchos más incluso diversificando y optimizando tus servicios y oportunidades de atención como nunca antes.',

       buttonStyles: "lg:max-w-62.5 h-11 py-0 rounded-5.5 text-base lg:mb-54px xl:mb-0 bg-btn",
       TextsStyles: "text-white  leading-6",

       buttonText: 'Registrate',
    },
    
  }),
  components: {
    Banner,
    SecondaryBanner,
    ThirdBanner,
  },
};
</script>
<style>
.Banner{
  background-image: linear-gradient(90deg, rgba(68, 109, 175, 0.8) 12.99%, rgba(68, 109, 175, 0) 140.69%), url('../../../../v2/src/assets/images/Banner.webp');
}
</style>